export default __webpack_public_path__ + "static/media/upload.f9612a20.svg";